import React, { useMemo } from 'react';

import styles from './Velocity.module.scss';

function getSize(task, units) {
  if (units === 'tasks') {
    return 1;
  } else {
    return task.estimate[units] || 0;
  }
}

/**
 * Splits a sprint's completed work into planned (in the sprint at its start),
 * support (added after the start), and bonus.
 */
export function deliveredBreakdown(sprint, units) {
  const initialTasks = (sprint?.initial_tasks || []).reduce((acc, task) => {
    acc[task.key] = task;
    return acc;
  }, {});

  return sprint.all_tasks.reduce(
    (acc, task) => {
      // Resolved work that left the sprint (including via a removed status) wasn't delivered
      if (task.resolution !== 'done' || task.sprint_presence === 'removed') {
        return acc;
      }

      const size = getSize(task, units);

      if (initialTasks[task.key]) {
        acc.planned = acc.planned + size;
      } else {
        acc.support = acc.support + size;
      }
      return acc;
    },
    { planned: 0, support: 0, bonus: 0 }
  );
}

function Sprint({
  sprint,
  committedWidth,
  deliveredWidth,
  gapWidth,
  yScale,
  chartHeight,
  units,
}) {
  const { metrics } = sprint;
  const { planned, support, bonus } = useMemo(
    () => deliveredBreakdown(sprint, units),
    [sprint, units]
  );

  return (
    <g>
      <g>
        <rect
          x={0}
          y={yScale(metrics.committed[units])}
          width={committedWidth}
          height={chartHeight - yScale(metrics.committed[units])}
          className={styles.committed}
        />
        {/* Start-of-sprint sizes, to compare with the commitment */}
        <rect
          x={0}
          y={yScale(metrics.completed_of_committed_at_start[units])}
          width={committedWidth}
          height={
            chartHeight - yScale(metrics.completed_of_committed_at_start[units])
          }
          className={styles['completed-of-committed']}
        />
      </g>
      <g transform={`translate(${committedWidth + gapWidth}, 0)`}>
        {bonus > 0 && (
          <rect
            x={0}
            y={yScale(planned + support + bonus)}
            width={deliveredWidth}
            height={chartHeight - yScale(planned + support + bonus)}
            className={styles.bonus}
          />
        )}
        {planned > 0 && (
          <rect
            x={0}
            y={yScale(planned + support)}
            width={deliveredWidth}
            height={chartHeight - yScale(planned + support)}
            className={styles.planned}
          />
        )}
        {support > 0 && (
          <rect
            x={0}
            y={yScale(support)}
            width={deliveredWidth}
            height={chartHeight - yScale(support)}
            className={styles.support}
          />
        )}
      </g>
    </g>
  );
}

export default Sprint;
